module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header__icon-container"
  }, [_c('a', {
    attrs: {
      "href": "http://www.mirrormedia.mg"
    },
    on: {
      "click": function($event) {
        _vm.backToHome()
      }
    }
  }, [_c('img', {
    staticClass: "header__logo",
    attrs: {
      "src": require("../assets/blue-logo.png"),
      "alt": "鏡週刊 Mirror Media"
    }
  })]), _vm._v(" "), _c('Share')], 1), _vm._v(" "), (_vm.dataStoryId !== 'landing-page' && _vm.dataStoryId !== 'ending-page') ? _c('div', {
    staticClass: "header__sidebar-toggler-container"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$emit('toggleSidebar')
      }
    }
  }, [_c('PartitionNav', {
    attrs: {
      "story": _vm.dataStoryIndex,
      "section": _vm.dataSectionIndex,
      "theme": _vm.theme
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eea357f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appHeader.vue
// module id = 120
// module chunks = 1